<div class="thp-container">
  <app-talent-happy-path-header></app-talent-happy-path-header>
  <div class="thp-container-body">
    <div class="thp-message wide-container">
      <h3>{{'double-opt-in.confirm.header' | translate}}</h3>
      <p>{{'double-opt-in.confirm.sub-text' | translate}}</p>
    </div>
  </div>
  <app-talent-happy-path-footer class="thp-footer"></app-talent-happy-path-footer>
</div>
